<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <div class="mb-4 font-weight-bold">Dodaj ostale autore</div>
      </v-col>
      <v-col :cols="getDeviceType === 'touch' ? 12 : 10">
        <v-autocomplete
          dense
          :items="getAkademskoOsoblje.data"
          v-model="selectedOsoblje"
          item-text="punoIme"
          :loading="$wait.is('getAkademskoOsoblje')"
          multiple
          :search-input.sync="searchInputUposlenik"
          label="Unesi ime i prezime da biste pretražili uposlenike"
          return-object
          hide-selected
          outlined
        >
          <template v-slot:selection> </template>
        </v-autocomplete>
      </v-col>
      <v-col :cols="getDeviceType === 'touch' ? 12 : 10">
        <v-autocomplete
          dense
          :items="getStraniAutori.data"
          v-model="selectedStraniAutori"
          item-text="punoIme"
          :loading="$wait.is('getStraniAutori')"
          multiple
          :search-input.sync="searchInputStrani"
          label="Unesi ime i prezime da biste pretražili strane autore"
          return-object
          hide-selected
          outlined
        >
          <template v-slot:selection> </template>
        </v-autocomplete>
      </v-col>
      <v-col :cols="getDeviceType === 'touch' ? 12 : 10">
        <v-autocomplete
          dense
          :items="getStudenti.data"
          v-model="selectedStudenti"
          :loading="$wait.is('getStudenti')"
          multiple
          item-text="punoIme"
          :search-input.sync="searchInputOsoba"
          label="Unesi ime i prezime da biste pretražili studente"
          return-object
          hide-selected
          outlined
        >
          <template v-slot:selection> </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row>
      <v-btn small @click="setShowForm" text color="primary"
        >Dodaj stranog autora koji nije na listi</v-btn
      >
    </v-row>
    <br />
    <v-dialog
      v-model="getShowForm"
      :fullscreen="!$vuetify.breakpoint.mdAndUp"
      max-width="600px"
    >
      <v-card>
        <v-form ref="form">
          <v-card-title style="background-color: rgb(8, 71, 118)">
            <span style="color: white">Dodaj stranog autora</span>
            <v-spacer></v-spacer>
            <v-icon color="white" @click="close">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="pa-2">
            <v-row class="d-flex align-center justify-center ml-3 mr-3">
              <v-col :cols="getDeviceType === 'touch' ? 12 : 12" class="pb-1">
                <v-text-field
                  dense
                  v-model="name"
                  label="Unesi ime*"
                  required
                  :rules="[rules.nameRules]"
                ></v-text-field>
              </v-col>
              <v-col :cols="getDeviceType === 'touch' ? 12 : 12" class="pb-1">
                <v-text-field
                  dense
                  v-model="surname"
                  label="Unesi prezime*"
                  required
                  :rules="[rules.surnameRules]"
                ></v-text-field>
              </v-col>
              <v-col :cols="getDeviceType === 'touch' ? 12 : 6" class="pb-1">
                <!-- <v-text-field
          dense v-model="akadStupanj" label="Odaberi akademski stupanj" required></v-text-field> -->
                <v-autocomplete
                  dense
                  v-model="akadStupanj"
                  :items="getAkademskiStupnjevi"
                  label="Odaberi akademski stupanj"
                  item-text="naziv"
                  return-object
                  :search-input.sync="searchInputStupanj"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="getDeviceType === 'touch' ? 12 : 6" class="pb-1">
                <v-autocomplete
                  dense
                  v-model="title"
                  :items="getZvanja"
                  label="Odaberi titulu"
                  item-text="naziv"
                  return-object
                  :search-input.sync="searchInputTitula"
                ></v-autocomplete>
                <!-- <v-text-field
          dense v-model="title" label="Odaberi titulu" required></v-text-field> -->
              </v-col>
              <v-col :cols="getDeviceType === 'touch' ? 12 : 12" class="pb-1">
                <v-text-field
                  dense
                  v-model="organizacija"
                  label="Unesi organizaciju*"
                  required
                  :rules="[rules.orgRules]"
                ></v-text-field>
              </v-col>
              <v-col :cols="getDeviceType === 'touch' ? 12 : 12" class="pb-1">
                <v-text-field
                  dense
                  v-model="sifra"
                  label="Unesi šifru autora*"
                  required
                  :rules="[rules.passwordRules]"
                ></v-text-field>
              </v-col> </v-row
          ></v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-2 mr-4 mb-3"
              color="rgb(8, 71, 118)"
              style="color: white"
              @click="addStraniAutor"
              :disabled="!isValid"
            >
              Dodaj autora
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-row v-if="getOdabraniUposleniciAutori.length > 0" no-gutters>
      <v-col cols="12" class="mt-3">
        <h3>Odabrani Autori</h3>
        <v-divider></v-divider>
      </v-col>
      <v-col :cols="getDeviceType === 'touch' ? 12 : 10" class="mr-n3">
        <v-card
          elevation="2"
          style=""
          class="mt-3 pa-0"
          color="accent"
          v-for="item in getOdabraniUposleniciAutori"
          :key="item.id"
        >
          <v-card-title
            class="d-flex justify-center align-center pa-0 pr-3 pl-3"
          >
            <p
                v-if="item.puno_ime"
                :class="$vuetify.breakpoint.mdAndUp ? '' : 'text-break'"
                :style="$vuetify.breakpoint.mdAndUp ? '' : 'max-width: 8rem'"
            >
              {{ item.puno_ime }}
            </p>
            <p
                v-else
              :class="$vuetify.breakpoint.mdAndUp ? '' : 'text-break'"
              :style="$vuetify.breakpoint.mdAndUp ? '' : 'max-width: 8rem'"
            >
              {{ item.ime }} {{ item.prezime }}
            </p>
            <v-spacer></v-spacer>
            <div
              v-if="
                getOdabraniUposleniciAutori.length +
                  getOdabraniStudentAutori.length +
                  getOdabraniStraniAutori.length >
                1
              "
              style="width: 90px; height 100%"
            >
              <v-autocomplete
                class="mt-4 pa-0"
                dense
                :ref="item.punoIme"
                v-if="
                  getOdabraniUposleniciAutori.length +
                    getOdabraniStudentAutori.length +
                    getOdabraniStraniAutori.length >
                  1
                "
                :value.sync="item.redBr"
                v-model="item.redBr"
                :items="selectionNumbers"
                label="Poredak"
                @change="provjeriPoredak(item)"
              ></v-autocomplete>
            </div>
            <v-btn fab icon @click="removeFromSelectedUposleniciAuthors(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getOdabraniStraniAutori.length > 0" no-gutters>
      <v-col :cols="getDeviceType === 'touch' ? 12 : 10" class="mr-n3">
        <v-card
          elevation="2"
          style=""
          class="mt-3 pa-0"
          color="accent"
          v-for="item in getOdabraniStraniAutori"
          :key="item.id"
        >
          <v-card-title
            class="d-flex justify-center align-center pa-0 pr-3 pl-3"
          >
            <p
              :class="$vuetify.breakpoint.mdAndUp ? '' : 'text-break'"
              :style="$vuetify.breakpoint.mdAndUp ? '' : 'max-width: 8rem'"
            >
              {{ item.ime }} {{ item.prezime }}
            </p>
            <v-spacer></v-spacer>
            <div
              v-if="
                getOdabraniUposleniciAutori.length +
                  getOdabraniStudentAutori.length +
                  getOdabraniStraniAutori.length >
                1
              "
              style="width: 90px; height 100%"
            >
              <v-autocomplete
                class="mt-4 pa-0"
                dense
                :ref="item.punoIme"
                v-if="
                  getOdabraniUposleniciAutori.length +
                    getOdabraniStudentAutori.length +
                    getOdabraniStraniAutori.length >
                  1
                "
                :value.sync="item.redBr"
                v-model="item.redBr"
                :items="selectionNumbers"
                label="Poredak"
                @change="provjeriPoredak(item)"
              ></v-autocomplete>
            </div>
            <v-btn fab icon @click="removeFromSelectedStraniAuthors(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="getOdabraniStudentAutori.length > 0" no-gutters>
      <v-col :cols="getDeviceType === 'touch' ? 12 : 10" class="mr-n3">
        <v-card
          elevation="2"
          style=""
          class="mt-3 pa-0"
          color="accent"
          v-for="item in studenti"
          :key="item.id"
        >
          <v-card-title
            class="d-flex justify-center align-center pa-0 pr-3 pl-3"
          >
            <p
              :class="$vuetify.breakpoint.mdAndUp ? '' : 'text-break'"
              :style="$vuetify.breakpoint.mdAndUp ? '' : 'max-width: 8rem'"
            >
              {{ item.ime }} {{ item.prezime }}
            </p>
            <v-spacer></v-spacer>
            <div
              v-if="
                getOdabraniUposleniciAutori.length +
                  getOdabraniStudentAutori.length +
                  getOdabraniStraniAutori.length >
                1
              "
              style="width: 90px; height 100%"
            >
              <v-autocomplete
                class="mt-4 pa-0"
                dense
                :ref="item.punoIme"
                v-if="
                  getOdabraniUposleniciAutori.length +
                    getOdabraniStudentAutori.length +
                    getOdabraniStraniAutori.length >
                  1
                "
                :value.sync="item.redBr"
                v-model="item.redBr"
                :items="selectionNumbers"
                label="Poredak"
                @change="provjeriPoredak(item)"
              ></v-autocomplete>
            </div>
            <v-btn fab icon @click="removeFromSelectedStudentAuthors(item)">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { waitFor } from "vue-wait";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "getAkademskiStupnjevi",
      "getZvanja",
      "getStudenti",
      "getAkademskoOsoblje",
      "getStraniAutori",
      "getPotentialAutors",
      "getOdabraniAutori",
      "getDeviceType",
      "getOdabraniStudentAutori",
      "getOdabraniUposleniciAutori",
      "getOdabraniStraniAutori",
      "getShowForm",
      "getUser",
    ]),
    isValid() {
      return (
        this.name != "",
        this.surname != "",
        this.organizacija != "",
        this.sifra != ""
      );
    },
    searchInputOsoba: {
      set(value) {
        if (value) {
          waitFor("getStudenti", async function () {
            await this.$store.dispatch("getStudenti", {
              page: 1,
              search: value,
            });
          }).apply(this);
        }
      },
      get() {
        return "";
      },
    },
    searchInputUposlenik: {
      set(value) {
        if (value) {
          waitFor("getAkademskoOsoblje", async function () {
            await this.$store.dispatch("getAkademskoOsoblje", {
              page: 1,
              search: value,
            });
          }).apply(this);
        }
      },
      get() {
        return "";
      },
    },
    searchInputStrani: {
      set(value) {
        if (value) {
          waitFor("getStraniAutori", async function () {
            await this.$store.dispatch("getStraniAutori", {
              page: 1,
              search: value,
            });
          }).apply(this);
        }
      },
      get() {
        return "";
      },
    },
    searchInputTitula: {
      set(value) {
        if (value) {
          this.$store.dispatch("getZvanja", value);
        }
      },
      get() {
        return "";
      },
    },
    searchInputStupanj: {
      set(value) {
        if (value) {
          this.$store.dispatch("getAkademskiStupnjevi", value);
        }
      },
      get() {
        return "";
      },
    },
    selectedStudenti: {
      set(value) {
        if (value) {
          this.$store.dispatch("setSelectedStudenti", value);
        }
      },
      get() {
        return this.getOdabraniStudentAutori;
      },
    },
    selectedOsoblje: {
      set(value) {
        if (value) {
          console.log(value)
          this.$store.dispatch("setSelectedOsoblje", value);
        }
      },
      get() {
        return this.getOdabraniUposleniciAutori;
      },
    },
    selectedStraniAutori: {
      set(value) {
        if (value) {
          this.$store.dispatch("setSelectedStraniAutori", value);
        }
      },
      get() {
        return this.getOdabraniStraniAutori;
      },
    },
    studenti() {
      return this.getOdabraniStudentAutori;
    },
    uposlenici() {
      return this.getOdabraniUposleniciAutori;
    },
    strani() {
      return this.getOdabraniStraniAutori;
    },
    selectionNumbers() {
      let numbers = [];
      for (
        let i = 0;
        i <
        this.getOdabraniUposleniciAutori.length +
          this.getOdabraniStudentAutori.length +
          this.getOdabraniStraniAutori.length;
        i++
      ) {
        numbers.push(i + 1);
      }
      return numbers;
    },
  },
  data() {
    return {
      rules: {
        nameRules: (v) => !!v || "Ime je obavezno!",
        surnameRules: (v) => !!v || "Prezime je obavezno!",
        orgRules: (v) => !!v || "Organizacija je obavezna!",
        passwordRules: (v) => !!v || "Šifra je obavezna!",
      },
      autors: [],
      title: "",
      select: null,
      name: "",
      surname: "",
      akadStupanj: "",
      organizacija: "",
      sifra: "",
      selectedPosition: "",
      positions: ["Autor", "Koautor"],
    };
  },
  beforeCreate() {
    this.$store.dispatch("getStudenti", { item: 1, search: "" });
    this.$store.dispatch("getAkademskoOsoblje", { item: 1, search: "" });
    this.$store.dispatch("getStraniAutori", { page: 1, search: "" });
  },
  mounted() {
    // console.log(this.getUser)
    this.getUser.id = this.getUser.uposlenik_id
    this.$store.dispatch("setSelectedOsoblje", [this.getUser]);
  },
  methods: {
    provjeriPoredak(item) {
      // try {
        this.getOdabraniStudentAutori.forEach((e) => {
          if (e.id != item.id && e.redBr === item.redBr) {
            this.$store.dispatch("changeStudentPoredak", e);
            // e.redBr = null;
            // this.$refs[e.punoIme][0].internalSearch = null;
            // this.$refs[e.punoIme][0].internalValueinternalValue = null;
            // this.$refs[e.punoIme][0].value = null;
            // this.$refs[e.punoIme][0].searchText = null;
          }
        });
        this.getOdabraniUposleniciAutori.forEach((e) => {
          if (e.id != item.id && e.redBr === item.redBr) {
            this.$store.dispatch("changeUposleniciPoredak", e);
           
          }
        });
        this.getOdabraniStraniAutori.forEach((e) => {
          if (e.id != item.id && e.redBr === item.redBr) {
            this.$store.dispatch("changeStraniPoredak", e);

          }
        });
      // } catch (error) {
      //   return Promise.reject(error)
      // }
    },

    addStraniAutor() {
      let noviStraniAutor = {
        ime: this.name,
        prezime: this.surname,
        organizacija: this.organizacija,
        sifra: this.sifra,
      };
      if (this.akad_stupanj_id) {
        Object.assign(noviStraniAutor, {
          akad_stupanj_id: this.akad_stupanj_id,
        });
      }
      if (this.zvanje_id) {
        Object.assign(noviStraniAutor, { zvanje_id: this.zvanje_id });
      }
      this.$store
        .dispatch("createNewStraniAutor", noviStraniAutor)
        .then((res) => {
          Object.assign(res, { punoIme: res.ime + " " + res.prezime });
          // this.odabraniAutori.push(res)
          this.$store.dispatch("setSelectedStraniAutori", [res]);
          this.name = null;
          this.surname = null;
          this.title = null;
          this.akadStupanj = null;
          this.organizacija = null;
          this.sifra = null;
          this.$store.dispatch("setShowForm", false);
          this.$refs.form.reset();
        });
    },
    close() {
      this.name = null;
      this.surname = null;
      this.title = null;
      this.akadStupanj = null;
      this.organizacija = null;
      this.sifra = null;
      this.$store.dispatch("setShowForm", false);
      this.$refs.form.reset();
    },
    removeFromSelectedUposleniciAuthors(autor) {
      let selectedToDelete = this.getOdabraniUposleniciAutori.find(
        (SA) => SA.id === autor.id
      );
      let index = this.getOdabraniUposleniciAutori.indexOf(selectedToDelete);
      let remaining = this.getOdabraniUposleniciAutori.filter(
        (a) => a.id != selectedToDelete.id
      );
      if (index > -1) {
        let restStu = [];
        this.getOdabraniStudentAutori.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          restStu.push(aut);
        });
        this.$store.commit("SET_REMAINING_STUDENT_AUTHORS", restStu);
        let strani = [];
        this.getOdabraniStraniAutori.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          strani.push(aut);
        });
        this.$store.commit("SET_REMAINING_STRANI_AUTHORS", strani);
        let uposlenici = [];
        remaining.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          uposlenici.push(aut);
        });
        this.$store.commit("SET_REMAINING_UPOSLENICI_AUTHORS", uposlenici);
      }
    },
    removeFromSelectedStudentAuthors(autor) {
      let selectedToDelete = this.getOdabraniStudentAutori.find(
        (SA) => SA.id === autor.id
      );
      let index = this.getOdabraniStudentAutori.indexOf(selectedToDelete);
      let remaining = this.getOdabraniStudentAutori.filter(
        (a) => a.id != selectedToDelete.id
      );
      if (index > -1) {
        let restStu = [];
        remaining.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          restStu.push(aut);
        });
        this.$store.commit("SET_REMAINING_STUDENT_AUTHORS", restStu);
        let strani = [];
        this.getOdabraniStraniAutori.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          strani.push(aut);
        });
        this.$store.commit("SET_REMAINING_STRANI_AUTHORS", strani);
        let uposlenici = [];
        this.getOdabraniUposleniciAutori.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          uposlenici.push(aut);
        });
        this.$store.commit("SET_REMAINING_UPOSLENICI_AUTHORS", uposlenici);
      }
    },
    removeFromSelectedStraniAuthors(autor) {
      let selectedToDelete = this.getOdabraniStraniAutori.find(
        (SA) => SA.id === autor.id
      );
      let index = this.getOdabraniStraniAutori.indexOf(selectedToDelete);
      let remaining = this.getOdabraniStraniAutori.filter(
        (a) => a.id != selectedToDelete.id
      );
      if (index > -1) {
        let restStu = [];
        this.getOdabraniStudentAutori.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          restStu.push(aut);
        });
        this.$store.commit("SET_REMAINING_STUDENT_AUTHORS", restStu);
        let strani = [];
        remaining.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          strani.push(aut);
        });
        this.$store.commit("SET_REMAINING_STRANI_AUTHORS", strani);
        let uposlenici = [];
        this.getOdabraniUposleniciAutori.forEach((aut) => {
          if (aut.redBr > selectedToDelete.redBr) {
            aut.redBr = aut.redBr - 1;
          }
          uposlenici.push(aut);
        });
        this.$store.commit("SET_REMAINING_UPOSLENICI_AUTHORS", uposlenici);
      }
    },
    setShowForm() {
      this.$store.dispatch("setShowForm", !this.getShowForm);
    },
  },
};
</script>

